var _path, _path2;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }

import React from "react";

var SvgTransaction = function SvgTransaction(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 24,
    viewBox: "0 0 33 24",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.975772,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9412 12.4874V1.69945C17.5578 0.566484 14.1727 0 10.7859 0C7.39909 0 3.80379 0.566484 0 1.69945V12.4874C0 17.5016 2.7452 19.7566 7.17903 22.1938L10.4706 24L13.7622 22.1938C18.196 19.7566 20.9412 17.5016 20.9412 12.4874ZM10.4729 14.523L15.4219 11.5212L10.4729 3.08504L5.5206 11.5212L10.4729 14.523ZM5.5206 12.4852L10.4729 15.487L15.4252 12.4852L10.4729 19.6468L5.5206 12.4852Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.946 17.9269L32.6362 11.2366L25.946 4.54636L25.946 8.93036H23.0564V13.3144H25.946L25.946 17.9269Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTransaction, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/transaction.ab44e50a.svg";
export { ForwardRef as ReactComponent };